export default __webpack_public_path__ + "9eb66a717480f2335a78477955e17987.svg";